import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';

const RecipeInstructions = ({ recipe }) => {
  const theme = useTheme();
  
  if (!recipe) return null;
  
  const { description, instructions, origin, glassware } = recipe;
  
  return (
    <Box sx={{ mt: 2 }}>
      {description && (
        <Typography 
          variant="body1" 
          paragraph
          sx={{ 
            fontSize: '0.95rem', 
            mb: 1.5,
            color: theme.palette.text.primary
          }}
        >
          {description}
        </Typography>
      )}
      
      {glassware && (
        <Typography 
          variant="body2" 
          sx={{ 
            mb: 1.5, 
            fontSize: '0.95rem',
            color: theme.palette.text.primary
          }}
        >
          <Box component="span" sx={{ fontWeight: 500 }}>Served in:</Box> {glassware}
        </Typography>
      )}
      
      <Typography 
        variant="body2" 
        sx={{ 
          mb: 1.5, 
          fontSize: '0.95rem',
          color: theme.palette.text.primary
        }}
      >
        <Box component="span" sx={{ fontWeight: 500 }}>Instructions:</Box> {instructions}
      </Typography>
      
      <Typography 
        variant="body2" 
        sx={{ 
          fontSize: '0.95rem',
          color: theme.palette.text.primary
        }}
      >
        <Box component="span" sx={{ fontWeight: 500 }}>Origin:</Box> {origin}
      </Typography>
    </Box>
  );
};

export default RecipeInstructions; 